// extracted by mini-css-extract-plugin
export default {"grid":"detail_grid__J6r8I","sidebar":"detail_sidebar__5JpPb","main":"detail_main__LSsPR","tabsCard":"detail_tabsCard__xEM0-"};